import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`
  max-width: 95vw;
 min-width:85vw;
  height: 85vh;
  margin-top: 10vh;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content:space-between;
  align-items: flex-end;
`;

export const Body = styled.div`
  background-color: ${theme.colors.darkGrey};
  width: 100%;
  height: 90%;
`;

interface ButtonAbaProps {
  focus: boolean;
}
export const ButtonAba = styled.button<ButtonAbaProps>`
  background-color: ${theme.colors.darkGrey};
  opacity: ${({ focus }) => (focus ? 1 : 0.7)};
  color: ${theme.colors.dark};
  font-size: max(10px, 1.2vw);
  padding: 1vh 2vw;
`;
export const TableContainer = styled.div`
  margin: auto;
 width: 95%;

  display: block;

  overflow-x/*(eixo x)*/: auto; /*Agora quando necessário a rolagem da tabela é permitida(funcionamento para o mobile)*/

  
  margin-bottom: 10px;
  overflow-y: scroll;
  height: 100%;
  &::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vw;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.dark}; /* color of the scroll thumb */
    border-radius: 0.25rem; /* roundness of the scroll thumb */
    height: 2px;
  }
`;
export const Table = styled.table`
  width: 40%;
  margin: auto;
  padding-top: 2vh;
  color: ${theme.colors.light};
`;

export const HeaderTable = styled.tr`
  position: sticky;
  top: 0;
  z-index: 1;
  color: ${theme.colors.light};
  background-color: ${theme.colors.darkGrey};
`;

export const HeaderItem = styled.td`
  text-align: center;
  padding-left: 2vw;
  padding-right: 2vw;
  padding-top: 1.5vh;
  padding-bottom: 1.5vh;
  font-size: max(10px, 1.2vw);
  white-space: nowrap;
`;

export const TableData = styled.td`
  text-align: center;

  color: ${theme.colors.dark};
  background-color: ${theme.colors.light};
  border: none;

  white-space: nowrap; /*Não permitir quebra de linha*/
  font-size: max(1vw, 10px);

  padding: 1vh 1vw;
`;
export const TBody = styled.tbody``;
export const TabelaLinha = styled.tr`
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

export const PLoader = styled.p`
  color: ${theme.colors.darkGrey};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PrefeiturasDiv = styled.div`
  width: 100%;
`;

export const ItemPrefeitura = styled.button`
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;

  width: 100%;

  background-color: ${theme.colors.light};
  &:hover {
    opacity: 0.8;
  }

  margin-bottom: 2vh;

  padding: 1vh 2vw;

  border-radius: 0.25rem;
`;

export const LogoPrefeitura = styled.img`
  width: max(5vw, 30px);
  height: max(5vw, 30px);
  
`;

export const ImageHelper = styled.div`

  display: flex;
  align-items: flex-start;
  
`;

export const TitlePrefeitura = styled.h2`
  font-size: max(10px, 1.2vw);
  color: ${theme.colors.dark};
  margin-left: 1vw;
  white-space: nowrap;
`;

export const DivAbas = styled.div`


`;


export const DivFiltro = styled.div`

  font-size: max(10px, 1.2vw);
  display: flex;
  align-items: center;
  justify-content:center;

  background-color: ${theme.colors.darkGrey};


`;


export const ButtonFiltro = styled.button`

  font-size: max(10px, 1vw);
  display: flex;
  align-items: center;
  justify-content:center;

  background-color: ${theme.colors.darkGrey};

  color: ${theme.colors.dark};

  padding: 0.5vw 1vw;


`;